<template>
	<div class="center_right">
		<div class="center_commNav">
			<div class="center_commNavItem" @click="activeName=item.id" :class="{'active':activeName==item.id}" v-for="(item,index) in commNavs">{{item.name}}</div>
		</div>
		<div class="center_filter"></div>
		<div class="center_tables clearfix">
			<div class="center_tLeft">
				<img src="@/images/center_tLeftBack.png" class="center_tLeftBack" />
				<div class="center_tLeftInfo clearfix">
					<div class="center_tLeftDate">
						<div class="center_tLeftDateP1">当前日期：</div>
						<div class="center_tLeftDateP2">{{todayDate}}</div>
						<div class="center_tLeftDateP2">周{{todayWake}}</div>
					</div>
					<div class="center_tLeftData">
						<div class="center_tLeftDataP1">本周课程学习次数</div>
						<div class="center_tLeftDataP2">{{studyCount}}次</div>
						<div class="center_tLeftDataP1">本周实验操作次数</div>
						<div class="center_tLeftDataP2">{{resourceCount}}次</div>
					</div>
				</div>
			</div>
			<div class="center_tRight clearfix">
				<div class="center_examBox" id="examtime_chart"></div>
				<div class="center_examLabel">
					<div class="center_examLabelP1">
						在线考试次数<span class="warningColor">（{{examTimes.examineTotal}}次）</span>
					</div>
					<div class="center_examLabelP2 primary">
						已参加考试
						<div class="center_examNum">{{examTimes.examineCount}}次</div>
					</div>
					<div class="center_examLabelP2 warning">
						未参加考试
						<div class="center_examNum">{{examTimes.unExamineCount}}次</div>
					</div>
				</div>
			</div>
			<div class="center_statistical">
				<div class="lab_staLabel">课程学习进度统计</div>
				<div class="lab_staCards clearfix">
					<div class="lab_staCard center_staCardsone">
						<div class="lab_cardOneTitle">
							<span>学习进度</span>
							<div class="r">
								<el-select :popper-append-to-body='false' @change='initStudyTime' v-model="courseTypeId" placeholder="全部课程类型" clearable class='center_chartSelect'>
									<el-option :label="item.name" :value="item.id" v-for='(item,index) in typeList'></el-option>
								</el-select>
							</div>
						</div>
						<div class="center_cardChart" id='studytime_chart'></div>
					</div>
					<div class="lab_staCard center_staCardstwo">
						<div class="lab_cardOneTitle">
							<span>课程作业</span>
							<div class="r">
								<el-select :popper-append-to-body='false' @change='initWorkTime' v-model="courseId" placeholder="全部课程" clearable class='center_chartSelect'>
									<el-option :label="item.name" :value="item.id" v-for='(item,index) in courseList'></el-option>
								</el-select>
							</div>
						</div>
						<div class="center_cardChart" id='worktime_chart'></div>
					</div>
				</div>
			</div>
			<div class="center_statistical">
				<div class="lab_staLabel">实验信息对比分析</div>
				<div class="lab_staCards clearfix">
					<div class="lab_staCard center_staCardsthree">
						<div class="lab_cardOneTitle">
							<span>考核用时</span>
							<div class="r">
								<el-select :popper-append-to-body='false' @change='initPersonalTime' v-model="timeLabId" placeholder="全部实验" clearable class='center_chartSelect hasmargin'>
									<el-option :label="item.name" :value="item.id" v-if="item.mode == '2'" v-for='(item,index) in labList'></el-option>
								</el-select>
								<el-select :popper-append-to-body='false' @change='initPersonalTime' v-model="limitTime" placeholder="近几次" class='center_chartSelect'>
									<el-option :label="item.name" :value="item.id" v-for='(item,index) in personalTimes'></el-option>
								</el-select>
							</div>
						</div>
						<div class="center_cardChart" id='personaltime_chart'></div>
					</div>
					<div class="lab_staCard center_staCardsone">
						<div class="lab_cardOneTitle">
							<span>考核分数</span>
							<div class="r">
								<el-select :popper-append-to-body='false' @change='initPersonalScore' v-model="scoreLabId" placeholder="全部实验" clearable class='center_chartSelect hasmargin'>
									<el-option :label="item.name" :value="item.id" v-if="item.mode == '2'" v-for='(item,index) in labList'></el-option>
								</el-select>
								<el-select :popper-append-to-body='false' @change='initPersonalScore' v-model="limitCount" placeholder="近几次" class='center_chartSelect'>
									<el-option :label="item.name" :value="item.id" v-for='(item,index) in personalTimes'></el-option>
								</el-select>
							</div>
						</div>
						<div class="center_cardChart" id='personalscore_chart'></div>
					</div>
					<div class="lab_staCard center_staCardstwo">
						<div class="lab_cardOneTitle">
							<span>实验作业</span>
							<div class="r">
								<el-select :popper-append-to-body='false' @change='initLabWorkTime' v-model="workLabId" placeholder="全部实验" clearable class='center_chartSelect'>
									<el-option :label="item.name" :value="item.id" v-for='(item,index) in labList'></el-option>
								</el-select>
							</div>
						</div>
						<div class="center_cardChart" id='labworktime_chart'></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import echarts from 'echarts'
	require('echarts/theme/macarons')
	import { parseTime } from '@/filters/index.js'
	import { listMajorByPid } from '@/api/major'
	import { appCourseList } from '@/api/course'
	import { getTaskStatistical, getCourseProgress, getStudyCount, getResourceCount, examineTimeScoreCenter, vtTaskCommitNumCenter, getExamineStatistical } from '@/api/statistical.js'
	import { vrDetailPage } from "@/api/simulation.js"
	export default {
		data() {
			return {
				activeName: '1',
				commNavs: [{
					name: '我的统计',
					id: '1'
				}],
				personalTimes: [{
					name: '近七次',
					id: 7
				}, {
					name: '近十次',
					id: 10
				}, {
					name: '近十五次',
					id: 15
				}],
				typeList: [],
				courseList: [],
				labList: [],
				courseTypeId: '',
				courseId: '',
				timeLabId: '',
				limitTime: 7,
				scoreLabId: '',
				limitCount: 7,
				workLabId: '',
				//data
				examTimes: {},
				studyCount: 0,
				resourceCount: 0,
				todayDate: '',
				todayWake: '',
				examTimeChart: null,
				studyTimeChart: null,
				workTimeChart: null,
				personalTimeChart: null,
				personalScoreChart: null,
			};
		},
		created() {
			this.getWeekAllCount();
			this.getCurrentDate();
			this.getTypeList();
			this.getCourseList();
			this.getLabList();
			//统计
			this.initExamTime();
			this.initStudyTime();
			this.initWorkTime();
			this.initPersonalTime();
			this.initPersonalScore();
			this.initLabWorkTime();
		},
		methods: {
			getWeekAllCount() {
				getStudyCount().then(res => {
					this.studyCount = res.data || 0
				})
				getResourceCount().then(res => {
					this.resourceCount = res.data || 0
				})
			},
			getCurrentDate() {
				var nowDate = new Date();
				this.todayDate = parseTime(nowDate, '{y}-{m}-{d}');
				this.todayWake = parseTime(nowDate, '{a}');
			},
			getTypeList() {
				listMajorByPid({
					pid: this.majorIdForAll
				}).then(res => {
					this.typeList = res.data;
				})
			},
			getCourseList() {
				appCourseList({
					majorId: this.majorIdForAll,
					current: 1,
					limit: 1000
				}).then(res => {
					this.courseList = res.data.records
				})
			},
			getLabList() {
				vrDetailPage({
					majorId: this.majorIdForAll,
					current: 1,
					limit: 1000
				}).then(res => {
					this.labList = res.data.records
				})
			},
			handleTime(limitTime) {
				this.limitTime = limitTime;
				this.initPersonalTime()
			},
			handleCommand(limitCount) {
				this.limitCount = limitCount;
				this.initPersonalScore()
			},
			initExamTime() {
				getExamineStatistical().then(res => {
					if(res.code == "OK") {
						this.examTimes = res.data;
						var option = {
							tooltip: {
								trigger: 'item'
							},
							series: [{
								name: '在线考试参加次数',
								type: 'pie',
								radius: ['40%', '70%'],
								avoidLabelOverlap: false,
								color: ['#3E73EF', '#FD8601'],
								label: {
									show: false,
									position: 'center'
								},
								emphasis: {
									label: {
										show: true,
										fontSize: '14',
										fontWeight: 'bold'
									}
								},
								labelLine: {
									show: false
								},
								data: [{
										value: res.data.examineCount || 0,
										name: '已参加',
										color: '#3E73EF'
									},
									{
										value: res.data.unExamineCount || 0,
										name: '未参加',
										color: '#FD8601'
									},
								]
							}]
						};
						this.$nextTick(() => {
							if(!this.examTimeChart) {
								this.examTimeChart = echarts.init(document.getElementById('examtime_chart'));
							}
							this.examTimeChart.setOption(option)
						})
					}
				})
			},
			initStudyTime() {
				getCourseProgress({
					typeId: this.courseTypeId ? this.courseTypeId : null,
				}).then(res => {
					if(res.code == "OK") {
						const {
							data
						} = res;
						var courseName = [];
						var progress = [];
						data.map(item => {
							courseName.push(item.courseName);
							progress.push(item.progress ? item.progress : 0);
						})
						var option = {
							tooltip: {
								trigger: 'axis',
								formatter: '{a} <br/>{b}: {c}%'
							},
							toolbox: {
								show: true,
								orient: 'vertical',
								left: 'right',
								top: 'center',
							},
							grid: {
								bottom:'90px',
								left:'40px',
								right:'40px',
							},
							xAxis: {
								type: 'category',
								data: courseName,
								axisPointer: {
									type: 'line'
								},
								axisLabel: {
									interval: 0,
									textStyle: {
										color: "black",
										fontSize: 12,
										fontWeight: 'initial',
										fontFamily: 'Microsoft YaHei'
									},
									interval: 0, //显示所有X轴信息
									rotate: 20 //倾斜角度
								}
							},
							yAxis: {
								type: 'value',
								minInterval: 1,
								name: '百分比',
								axisTick: {
									lineStyle: {
										width: 0
									}
								},
							},
							series: [{
								name: '课程学习进度',
								data: progress,
								type: 'bar',
								barWidth: 20,
								color: '#3E73EF',
							}]
						};
						this.$nextTick(() => {
							if(!this.studyTimeChart) {
								this.studyTimeChart = echarts.init(document.getElementById('studytime_chart'));
							}
							this.studyTimeChart.setOption(option)
						})
					}
				})
			},
			initWorkTime() {
				getTaskStatistical({
					courseId: this.courseId ? this.courseId : null,
				}).then(res => {
					if(res.code == "OK") {

						var option = {
							tooltip: {
								trigger: 'item'
							},
							legend: {
								bottom: '5%',
								left: 'center'
							},
							series: [{
								name: '在线考试参加次数',
								type: 'pie',
								radius: ['40%', '70%'],
								avoidLabelOverlap: false,
								color: ['#3E73EF', '#FD8601'],
								label: {
									show: false,
									position: 'center'
								},
								emphasis: {
									label: {
										show: true,
										fontSize: '14',
										fontWeight: 'bold'
									}
								},
								labelLine: {
									show: false
								},
								data: [{
										value: res.data.taskCount,
										name: '已提交',
										color: '#3E73EF'
									},
									{
										value: res.data.unTaskCount,
										name: '未提交',
										color: '#FD8601'
									},
								]
							}]
						};
						this.$nextTick(() => {
							if(!this.workTimeChart) {
								this.workTimeChart = echarts.init(document.getElementById('worktime_chart'));
							}
							this.workTimeChart.setOption(option)
						})
					}
				})
			},
			initPersonalTime() {
				examineTimeScoreCenter({
					limitCount: this.limitTime,
					vrDetailId: this.timeLabId ? this.timeLabId : null,
				}).then(res => {
					if(res.code == "OK") {
						this.initPersonalTimeChart(res)
					}
				})
			},
			initPersonalTimeChart(res) {
				var xAxisData = [];
				var yAxisTime = [];
				res.data.map(item => {
					xAxisData.push(parseTime(item.createTime, '{m}/{d}'));
					yAxisTime.push({
						name: item.vrName,
						value: item.personalTime,
					});
				})
				var option = {
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'line'
						},
						shadowStyle: {
							shadowColor: "rgba(44,184,243,0.5)",
						},
						formatter: function(data) {
							var returnStr = '';
							for(var i = 0; i < data.length; i++) {
								var info = data[i];
								returnStr += info.seriesName + '<br />' + info.name + '： ' + info.value + '分钟'
								if(i < data.length - 1) {
									returnStr += '<br />'
								}
							}
							return returnStr
						},
					},
					grid: {
						bottom: 30,
						top: 15,
						left: 65,
						right: 65,
					},
					xAxis: [{
						data: xAxisData,
						axisLabel: {
							show: true,
							textStyle: {
								color: '#6C7293', //更改坐标轴文字颜色
								fontSize: 14,
								lineHeight: 20,
							}
						},
					}],
					yAxis: [{
						name: '考核用时',
						minInterval: 1,
						type: 'value',
						axisLabel: {
							formatter: '{value}分钟'
						},
						axisTick: {
							lineStyle: {
								width: 0
							}
						},
						splitLine: {
							show: false
						},
					}],
					series: [{
						name: '考核用时',
						type: 'bar',
						data: yAxisTime,
						barWidth: 20,
						color: '#3E73EF',

					}]
				};
				this.$nextTick(() => {
					if(!this.personalTimeChart) {
						this.personalTimeChart = echarts.init(document.getElementById('personaltime_chart'));
					}
					this.personalTimeChart.setOption(option)
				})

			},
			initPersonalScore() {
				examineTimeScoreCenter({
					limitCount: this.limitCount,
					vrDetailId: this.scoreLabId ? this.scoreLabId : null,
				}).then(res => {
					if(res.code == "OK") {
						this.initPersonalScoreChart(res)
					}
				})
			},
			initPersonalScoreChart(res) {
				var xAxisData = [];
				var yAxisScore = [];
				res.data.map(item => {
					xAxisData.push(parseTime(item.createTime, '{m}/{d}'));
					yAxisScore.push({
						name: item.vrName,
						value: item.personalScore,
					});
				})
				var option = {
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'line'
						},
						shadowStyle: {
							shadowColor: "rgba(44,184,243,0.5)",
						},
						formatter: function(data) {
							var returnStr = '';
							for(var i = 0; i < data.length; i++) {
								var info = data[i];
								returnStr += info.seriesName + '<br />' + info.name + '： ' + info.value + '分'
								if(i < data.length - 1) {
									returnStr += '<br />'
								}
							}
							return returnStr
						},
					},
					grid: {
						bottom: 30,
						top: 15,
						left: 65,
						right: 65,
					},
					xAxis: [{
						data: xAxisData,
						axisLabel: {
							show: true,
							textStyle: {
								color: '#6C7293', //更改坐标轴文字颜色
								fontSize: 14,
								lineHeight: 20,
							}
						},
					}],
					yAxis: [{
						type: 'value',
						minInterval: 1,
						name: '考核得分',
						axisLabel: {
							formatter: '{value}分'
						},
						axisTick: {
							lineStyle: {
								width: 0
							}
						},
					}, ],
					series: [{
						name: '考核得分',
						type: 'line',
						data: yAxisScore,
						smooth: 0.2,
						color: '#2CB8F3',
					}]
				};
				this.$nextTick(() => {
					if(!this.personalScoreChart) {
						this.personalScoreChart = echarts.init(document.getElementById('personalscore_chart'));
					}
					this.personalScoreChart.setOption(option)
				})
			},
			initLabWorkTime() {
				vtTaskCommitNumCenter({
					vrDetailId: this.workLabId ? this.workLabId : null,
				}).then(res => {
					if(res.code == "OK") {
						var option = {
							tooltip: {
								trigger: 'item'
							},
							legend: {
								bottom: '5%',
								left: 'center'
							},
							series: [{
								name: '在线考试参加次数',
								type: 'pie',
								radius: ['40%', '70%'],
								avoidLabelOverlap: false,
								color: ['#3E73EF', '#FD8601'],
								label: {
									show: false,
									position: 'center'
								},
								emphasis: {
									label: {
										show: true,
										fontSize: '14',
										fontWeight: 'bold'
									}
								},
								labelLine: {
									show: false
								},
								data: [{
										value: res.data.isFinish || 0,
										name: '已提交',
										color: '#3E73EF'
									},
									{
										value: res.data.noFinish || 0,
										name: '未提交',
										color: '#FD8601'
									},
								]
							}]
						};
						this.$nextTick(() => {
							if(!this.labworkTimeChart) {
								this.labworkTimeChart = echarts.init(document.getElementById('labworktime_chart'));
							}
							this.labworkTimeChart.setOption(option)
						})
					}
				})
			},
		},
	};
</script>